import * as React from 'react';

import { Box, Checkbox } from '@coursera/coursera-ui';

import { Spacer } from 'bundles/enterprise-ui/components';

import _t from 'i18n!nls/enterprise-admin-skills';

const OrgLevelSkillSetToggle = ({
  filterOrgLevelOnly,
  toggleOrgLevelSkillSets,
  toggleAllSkillSets,
}: {
  filterOrgLevelOnly: boolean;
  toggleOrgLevelSkillSets: () => void;
  toggleAllSkillSets: () => void;
}) => (
  <div>
    <Box justifyContent="start" alignItems="center">
      <strong>{_t('What SkillSets do you want to see?')}</strong>
      <Box justifyContent="around" alignItems="center" flex={1}>
        <div>
          <Checkbox checked={filterOrgLevelOnly} isRadio={true} onChange={toggleOrgLevelSkillSets}>
            <span style={{ marginLeft: '10px' }}>{_t('Only SkillSets in my organization')}</span>
          </Checkbox>
        </div>
        <div>
          <Checkbox checked={!filterOrgLevelOnly} isRadio={true} onChange={toggleAllSkillSets}>
            <span style={{ marginLeft: '10px' }}>{_t('All SkillSets available from Coursera')}</span>
          </Checkbox>
        </div>
      </Box>
    </Box>
    <Spacer size={24} />
  </div>
);

export default OrgLevelSkillSetToggle;
